import { PermissionChoose, PermissionStatusMap } from "@/constants/share";
import fridayReporter from "@/utils/friday";
import RSelect from "@/component/RSelect";
import { useMemo } from "react";

const permissionOptions = [
    {
      label: (
        <div className="flex px-2 font-400">
          所有人<div className="color-#191D26 font-600">可查看</div>
        </div>
      ),
      selectLabel: (
        <div className="flex font-400">
          所有人<div className="color-#191D26 font-600">可查看</div>
        </div>
      ),
      value: PermissionChoose.Check,
      hide: false,
    },
    {
      label: (
        <div className="flex px-2 font-400">
          所有人
          <div className="color-#191D26 font-600">输入密码可查看</div>
        </div>
      ),
      selectLabel: (
        <div className="flex font-400">
          所有人
          <div className="color-#191D26 font-600">输入密码可查看</div>
        </div>
      ),
      value: PermissionChoose.Password,
    },
    {
      label: (
        <div className="flex px-2 font-400">
          企业内成员<div className="color-#191D26 font-600">可查看</div>
        </div>
      ),
      selectLabel: (
        <div className="flex font-400">
          企业内成员<div className="color-#191D26 font-600">可查看</div>
        </div>
      ),
      value: PermissionChoose.StaffCheck,
    },
    {
      label: (
        <div className="flex px-2 font-400">
          企业内成员
          <div className="color-#191D26 font-600">输入密码可查看</div>
        </div>
      ),
      selectLabel: (
        <div className="flex font-400">
          企业内成员
          <div className="color-#191D26 font-600">输入密码可查看</div>
        </div>
      ),
      value: PermissionChoose.StaffPassword,
    },
  ];
interface PermissionScopeSelectProps {
  permissionChoose?: PermissionChoose;
  disabled?: boolean;
  isCompany: boolean;
  setPermissionChoose: (permissionChoose: PermissionChoose) => void;
}

const PermissionScopeSelect = ({
  permissionChoose,
  disabled,
  isCompany,
  setPermissionChoose,
}: PermissionScopeSelectProps) => {
  const showPermissionOptions = useMemo(() => {
    const copyOptions = [...permissionOptions];
    return isCompany
      ? copyOptions.map((item) => {
          item.hide = false;
          return item;
        })
      : copyOptions.map((item) => {
          if (
            [
              PermissionChoose.StaffCheck,
              PermissionChoose.StaffPassword,
            ].includes(item.value)
          ) {
            item.hide = true;
          }
          return item;
        });
  }, [isCompany]);

  return (
    <RSelect
      options={showPermissionOptions}
      value={permissionChoose as PermissionChoose}
      disabled={disabled}
      placement="bottomLeft"
      contentStyleWidth="18rem"
      title={
        <div className="pl-2 h-6 lh-6 text-3 text-mx-quaternary mb-1">
          分享范围
        </div>
      }
      selectContentClassName="px-4"
      onChange={(value) => {
        fridayReporter.pushData({
          eventCode: "SummaryPage_Share_Copylink_PermissionStatus",
          payload: {
            permission_status: PermissionStatusMap[value] || "",
          },
        });
        setPermissionChoose(value as PermissionChoose);
      }}
    />
  );
};

export default PermissionScopeSelect;
